<template>
  <div id="footer">
    <div v-show="this.isApp == false ? true : false">
      <div class="footer_main">
        <div class="footer-left">
          <p>
            <span>{{$t('footer.t1')}}</span>
            <span>{{$t('footer.t2')}}</span>
          </p>
          <p>{{ $t('footer.t3') }}</p>
          <p>{{ $t('footer.t4') }}</p>
          <p>{{ $t('footer.t5') }} <a class="goa" href="mailto:service@goodluck777.com">admin@tiger777.com</a></p>
          <!-- <p>© 2017 ARC PLAY LTD CO., Ltd. All Rights Reserved.</p> -->
          <div class="footer-privacy subb" @click="goAmt">
            <div class="footer-privacy_sub">{{ $t('footer.t6') }}</div> |
            <div class="footer-privacy_sub">{{ $t('footer.t7')}}</div> |
            <div class="footer-privacy_sub">{{ $t('footer.t8') }}</div> |
            <div class="footer-privacy_sub">{{ $t('footer.t9')}}</div>
          </div>
        </div>

        <div class="footer-right"><img src="../assets/index/generic_12.png" alt=""></div>
      </div>
    </div>


    <div v-show="this.isApp == false ? false : true">
      <div class="isapp_footer_main">
        <div class="footer-left" >
          <p>
            <span>{{$t('footer.t1')}}</span>
            <span>{{$t('footer.t2')}}</span>
          </p>
          <p>{{ $t('footer.t3') }}</p>
          <p>{{ $t('footer.t4') }}</p>
          <p>{{ $t('footer.t5') }}<a class="goa" href="mailto:service@goodluck777.com">admin@tiger777.com</a>
          </p>
          <!-- <p>© 2017 ARC PLAY LTD CO., Ltd. All Rights Reserved.</p> -->
          <div class="footer-privacy subb" @click="goAmt">
            <div class="footer-privacy_sub">{{ $t('footer.t6') }}</div> |
            <div class="footer-privacy_sub">{{ $t('footer.t7') }}</div> |
            <div class="footer-privacy_sub">{{ $t('footer.t8') }}</div> |
            <div class="footer-privacy_sub">{{ $t('footer.t9') }}</div>
          </div>
        </div>


        <div class="zhan"></div>
        <div class="is_footer-right"><img src="../assets/index/generic_12.png" alt=""></div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from "vuex";
export default {
  data() {
    return {
      isShow: true
    }
  },
  created() {
    this.changeLange()
  },
  mounted() {
    this.changeLange()
  },
  computed: {

    //获取STORE里isApp
    ...mapState({
      isApp(state) {
        return state.isApp;
      },
    }),
  },
  methods: {
    goAmt() {
      if (this.$route.path == "/Agreement") {
        this.goTop()
      } else {
        this.$router.push("/Agreement")
      }
    },
    changeLange() {
      // console.log('isApp',this.isApp) 
      // this.$nextTick(() => {
      //   let lang = localStorage.getItem("lang")
      //   console.log('lang', lang)
      //   if (lang == "zh") {
      //     this.isShow = true
      //   }
      //   if (lang == "en") {
      //     this.isShow = false
      //   }
      //   // console.log('this.isShow',this.isShow)
      // })
    },
    goTop() {
      let top = document.documentElement.scrollTop || document.body.scrollTop;
      // 实现滚动效果
      const timeTop = setInterval(() => {
        document.body.scrollTop =
          document.documentElement.scrollTop =
          top -=
          50;
        if (top <= 0) {
          clearInterval(timeTop);
        }
      }, 10);
    },
  }
}
</script>

<style lang="less" scoped="">
#footer {
  width: 100%;
  background-color: rgb(54, 0, 0);
}

.footer_main {
  width: 75rem;
  margin: 0 auto;
  padding: 0.625rem 0;
  position: relative;
}

.footer-privacy {
  color: white;
  display: flex;
  flex-direction: row;
  justify-content: center;

  .footer-privacy_sub {
    margin: 0 0.625rem;
  }
}

.goa {
  color: #ffba00;
}

.footer-right {
  position: absolute;
  bottom: 1.25rem;
  right: 1.875rem;

  .footer-right img {
    width: 3.5625rem;
    height: 4.8125rem;
  }
}

.footer-left p {
  font-size: 1rem;
}

.isapp_footer_main {
  margin: 0 auto;
  padding: 0.625rem 0.625rem;
  position: relative;
}

.is_footer-right {
  margin-top: 0.9375rem;

  .is_footer-right img {
    width: 3.5625rem;
    height: 4.8125rem;
  }
}
</style>
